import React, { Component } from 'react';
import { UncontrolledAlert } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CircularProgress } from 'material-ui/Progress';
import { FormControl } from 'material-ui/Form';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import Input, { InputLabel } from 'material-ui/Input';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';


import DataTable from './datatable';

import PageSubHeader from '../../pagesubheader'
import ContainerHeader from '../../../components/ContainerHeader/index';
import * as meetingdetails from '../../../actions/meetingdetails';
import * as loadswitchercommittees from '../../../actions/teamdetails';

class MeetingList extends Component {

    constructor(props) {
        super(props)
        this.state = {
            committee_id: Number(this.props.params.id ? this.props.params.id : this.props.loginUser.data.committee_id),
            filterText: '',
            inProgress: false,
        }
    }
    handleChangeTeam(e) {
        this.setState({ committee_id: Number(e.target.value) })
        this.props.actions.getMeetingDetailsList(e.target.value);
        this.props.loginUser.data.committee_id = e.target.value;
        this.props.actions.changePreferedTeamIdUser(this.props.loginUser.data)
    }

    componentDidMount() {
        // console.log('props', this.props)
        this.props.actions.loadswitchercommittees();
        if (this.state.committee_id > 0)
            this.props.actions.getMeetingDetailsList(this.state.committee_id);
    }

    handleUserInput(filterText) {
        this.setState({ filterText: filterText });
    };

    setInProgress(value) {
        this.setState({ inProgress: value });
    }

    render() {
        const { getDataList, teamDetails, match } = this.props;

        let dataList = <tr><td></td></tr>;
        let message = null;
        // console.log('getDataList', getDataList);
        if ((getDataList && getDataList.Status) || (teamDetails && teamDetails.Status) || this.state.inProgress) {
            message = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }
     
        return (
            <div className="slideInUpTiny ">
                {message}
                <ContainerHeader title="Meeting List" match={match} />
                <div className="row mb-md-4">
                    <div className="col-12">
                        <PageSubHeader committee_id={this.state.committee_id} handleChangeTeam={this.handleChangeTeam.bind(this)}
                            teamDetails={teamDetails}
                            onUserInput={this.handleUserInput.bind(this)} />
                        <div className="row">
                            <div className="col-12">
                                <DataTable data={getDataList && getDataList.meetingdetailsList && getDataList.meetingdetailsList.length > 0 ? getDataList.meetingdetailsList : null}
                                    filterText={this.state.filterText} setInProgress={this.setInProgress.bind(this)}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

function mapStateToProps(state, ownProps) {
    // console.log('state=>', state)
    const { loginUser, meetingDetails, teamDetails } = state
    const { match } = ownProps
    return { loginUser, getDataList: meetingDetails, teamDetails, params: ownProps.match.params, match }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, meetingdetails, loadswitchercommittees), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(MeetingList);



// WEBPACK FOOTER //
// ./app/meetingdetails/meetinglist/index.js